import { CompanyStatus } from '@/modules/Organization/components'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import {
  Box,
  Checkbox,
  Chip,
  createFilterOptions,
  Divider,
  Autocomplete as MuiAutocomplete,
  Paper,
  Popper,
  Stack,
} from '@mui/material'
import TextField from '@mui/material/TextField'
import type { FC } from 'react'
import { Controller, get, useFormContext } from 'react-hook-form'
import type { AutocompleteProps } from './types'

export const Autocomplete: FC<AutocompleteProps> = (props) => {
  const {
    name,
    label,
    multiple,
    placeholder = 'Выберите из списка',
    id,
    disabled,
    options = [],
    onInputChange,
    limitTags = 1,
    noOptionsText,
    size = 'medium',
    onChange: onSelectChange,
    slotProps,
    renderOption,
    filterOptions,
    defaultValue,
    readOnly,
    PopperComponent,
    PaperComponent,
    paddingTop,
    paddingBottom,
    popupIcon,
  } = props

  const { control, formState } = useFormContext()

  const error = get(formState.errors, name)

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange, ref } }) => {
        return (
          <MuiAutocomplete
            sx={{
              '& .MuiInputBase-root': {
                paddingTop: `${paddingTop}px`,
                paddingBottom: `${paddingBottom}px`,
              },
            }}
            readOnly={readOnly ?? false}
            limitTags={limitTags}
            disablePortal
            id={id}
            ref={ref}
            disabled={disabled}
            value={multiple ? value ?? [] : value ?? null}
            multiple={multiple}
            disableCloseOnSelect={multiple}
            renderTags={(tagValue, getTagProps) =>
              tagValue.map((option, index) => {
                const { key, ...tagProps } = getTagProps({ index })
                return (
                  <Chip
                    sx={{
                      backgroundColor: '#009FDA',
                      borderRadius: '4px',
                      color: 'white',
                      marginRight: '4px',
                    }}
                    key={key}
                    label={option.label}
                    // {...tagProps}
                    // disabled={fixedOptions.includes(option)}
                  />
                )
              })
            }
            options={options}
            noOptionsText={noOptionsText ?? 'Ничего не найдено'}
            getOptionLabel={(option) => option.label || ''}
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            renderOption={(props, option, { selected }, index) => (
              <li {...props} key={option.value || `${option.label}-${index}`}>
                {multiple ? (
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    // style={{ marginRight: '0px' }}
                    checked={selected}
                  />
                ) : null}
                {option?.status && (
                  <Stack
                    gap={'4px'}
                    sx={{ backgoundColor: 'red', width: '100%' }}
                  >
                    <CompanyStatus status={option?.status} />
                    <Box>{option?.short + ' ' + option?.label}</Box>
                    <p style={{ fontSize: '14px' }}>ИНН: {option?.inn}</p>
                    <p>
                      <span style={{ fontSize: '14px' }}>
                        {option?.address}
                      </span>
                    </p>
                    <Divider sx={{ margin: '8px 0', width: '100%' }} />
                  </Stack>
                )}
                {!option?.status && option?.label}
              </li>
            )}
            filterOptions={filterOptions ?? createFilterOptions()}
            onChange={(_, data) => {
              onChange(data)

              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              onSelectChange?.(data as any)
            }}
            size={size}
            slotProps={slotProps}
            onInputChange={onInputChange}
            renderInput={(params) => (
              <TextField
                focused
                error={error}
                helperText={error ? error.message : ``}
                label={label}
                hiddenLabel={!label}
                placeholder={placeholder}
                variant="filled"
                {...params}
                InputProps={{
                  ...params.InputProps,
                  readOnly: readOnly ?? false,
                  // disabled: readOnly ?? false,
                  // endAdornment: (
                  //   <InputAdornment position="end">
                  //     <OptionListIcon />
                  //   </InputAdornment>
                  // ),
                }}
              />
            )}
            popupIcon={popupIcon}
            PopperComponent={(props) =>
              PopperComponent ? (
                <PopperComponent {...props} />
              ) : (
                <Popper {...props} />
              )
            }
            PaperComponent={(props) =>
              PaperComponent ? (
                <PaperComponent {...props} />
              ) : (
                <Paper {...props} />
              )
            }
          />
        )
      }}
    />
  )
}
